<template>
  <div>
    <Row :gutter="16" type="flex">
      <Col :md="{ span: 8, order: 1 }" :sm="{ span: 12, order: 3 }" :xs="{ span: 24, order: 3 }"
        class-name="btnColStyle">
      <div class="user">
        <template v-if="isLogin">
          <span>{{ `当前用户：${userInfo.userName}` }}</span>
          <span @click="doLogin">退出</span>
        </template>
        <template v-else>
          <span>游客</span>
          <span @click="doLogout">登录</span>
        </template>
      </div>
      <Button v-for="btn in operat" :key="`operat${btn.name}`" type="primary" class="operate"
        :target="btn.isOpenUrl ? '_blank' : '_self'" :to="btn.to">
        <div class="container">
          <Icon :type="btn.icon" :size="40" />
          <span>{{ btn.name }}</span>
        </div>
      </Button>
      </Col>
      <Col v-for="item in news" :key="`news${item.name}`" :md="item.md" :sm="item.sm" :xs="item.sm">
      <Card :padding="0" class="info">
        <div class="head">
          <div class="title">{{ item.name }}</div>
          <span @click="$router.push({
            name: 'news',
            query: { type: item.type }
          })">更多>></span>
        </div>
        <MyList :type="item.type" :api="GetNewsinfos" :minHeight="225" :size="5" :pageVisible="false" />
      </Card>
      </Col>
      <Col :md="{ span: 8, order: 3 }" :sm="{ span: 12, order: 4 }" :xs="{ span: 24, order: 4 }"
        class-name="btnColStyle">
      <Card :padding="0" class="address">
        <div class="head">
          <div class="title">{{ config.cardTitle[2] }}</div>
        </div>
        <div class="content">
          <p v-for="(val, index) in config.address" :key="`address${index}`" v-html="val" />
        </div>
      </Card>
      </Col>
    </Row>
    <div>
      <div style="width:300px;margin:0 auto; padding:20px 0;">
        <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img src="../../image/ba.png" style="float:left;" />
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">赣公网安备
            36010402000399号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import MyList from '@components/list'
import { GetNewsinfos, SSOLoginOut } from '@api'
import { localStoragePackage } from '@libs/util'
export default {
  name: 'home',
  components: { MyList },
  data() {
    return {
      operat: [],
      news: [],
      GetNewsinfos,
    }
  },
  computed: {
    config() {
      return window.config
    },
    isLogin() {
      return !!this.userInfo.userName
    },
    userInfo() {
      return this.$store.state.user
    },
  },
  mounted() {
    this.buildOperat()
    this.builNews()
  },
  methods: {
    buildOperat() {
      this.operat = [
        {
          name: config.operateButtonText[3],
          to: 'search',
          icon: 'md-calendar',
        },
        {
          name: config.operateButtonText[2],
          to: 'record',
          icon: 'md-document',
        },
      ]
      if (config.operateButtonText[4]) {
        this.operat.push({
          name: config.operateButtonText[4],
          to: config.openUrl,
          isOpenUrl: true
        })
      }
    },
    builNews() {
      this.news = [
        {
          name: config.cardTitle[0],
          type: '3',
          md: { span: 16, order: 4 },
          sm: { span: 24, order: 2 },
        },
        {
          name: config.cardTitle[1],
          type: '2',
          md: { span: 16, order: 2 },
          sm: { span: 24, order: 1 },
        },
      ]
    },
    async doLogin() {
      try {
        const {
          data: { Code, Msg },
        } = await SSOLoginOut()
        if (Code === 0) {
          localStorage.clear()
          window.location.href = Msg
          window.location.href = window.config.baseArchiveUrl
        }
      } catch (e) {
        console.error(e)
      }
    },
    doLogout() {
      window.location.href = window.config.attestationUrl
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';

%card {
  margin-bottom: 16px;

  .head {
    height: 40px;
    line-height: 40px;
    background: #f9f9f9;
    display: flex;

    .title {
      width: 109px;
      font-weight: bold;
      background: #fff;
      text-align: center;
      border-top: 2px solid $default;
    }

    span {
      margin-left: auto;
      font-size: 12px;
      margin-right: 15px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
        color: $default;
        font-weight: bold;
      }
    }
  }

  .content {
    background: #fff;
  }
}

.info {
  @extend %card;
  overflow-y: auto;
  height: 430px;

  .list {
    .ivu-cell {
      padding: 10px 16px;
    }

    .icon {
      width: 12px;
      height: 12px;
      display: inline-block;
      vertical-align: middle;
      background: $default;
      border-radius: 100%;
      margin-right: 10px;
    }
  }
}

.address {
  @extend %card;
  flex: 1;

  .content {
    height: 220px;

    p {
      line-height: 24px;
      padding: 10px 16px;
    }
  }
}

.btnColStyle {
  display: flex;
  flex-direction: column;
}

.user {
  text-align: center;
  margin-bottom: 16px;

  span {
    margin: 0 12px;

    &:last-child {
      text-decoration: underline;
      cursor: pointer;
      font-weight: bold;
    }
  }
}

.operate {
  width: 100%;
  min-height: 100px;
  margin-bottom: 16px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  .container {
    display: flex;
    align-items: center;
    color: #fff;

    span {
      margin-left: 10px;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>

